import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { Observable, interval, switchMap, take, takeWhile } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BiometricService extends ApiBaseService {

  checkBiometricStatus(): Observable<any> {
    return this.get('/comercio/biometric/check');
  }

  sendSignatureDocument(verification_code: string): Observable<any> {
    return this.post('/comercio/signatura/send-document', { verification_code });
  }

  pollBiometricStatus(maxAttempts = 240, intervalMs = 5000): Observable<any> {
    return interval(intervalMs).pipe(
      take(maxAttempts),
      switchMap(() => this.checkBiometricStatus()),
      takeWhile((response: any) => !response?.data?.is_completed, true)
    );
  }
}
